(() => {
  class HeaderScrollController {
    constructor(header) {
      this.header = header;
      this.lastScrollY = window.scrollY;
      this.ticking = false;
      this.hideDistance = 12;
      this.downwardDistance = 0;

      this.handleScroll = this.handleScroll.bind(this);
    }

    connect() {
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    disconnect() {
      window.removeEventListener('scroll', this.handleScroll);
    }

    reveal() {
      this.header.classList.remove('is-hidden');
      this.downwardDistance = 0;
    }

    handleScroll() {
      if (this.ticking) return;

      this.ticking = true;

      window.requestAnimationFrame(() => {
        const currentScrollY = Math.max(window.scrollY, 0);
        const difference = currentScrollY - this.lastScrollY;
        const isMobileInterfaceOpen =
          document.body.classList.contains('mobile-menu-open') ||
          document.body.classList.contains('mobile-search-open');

        if (isMobileInterfaceOpen) {
          this.reveal();
          this.lastScrollY = currentScrollY;
          this.ticking = false;
          return;
        }

        if (currentScrollY <= 0 || difference < 0) {
          this.reveal();
        } else if (difference > 0) {
          this.downwardDistance += difference;

          if (
            this.downwardDistance >= this.hideDistance &&
            currentScrollY > this.header.offsetHeight
          ) {
            this.header.classList.add('is-hidden');
            this.downwardDistance = 0;
          }
        }

        this.lastScrollY = currentScrollY;
        this.ticking = false;
      });
    }
  }

  window.HeaderScrollController = HeaderScrollController;
})();
